import * as angular from "angular";
import { Division } from "../models/division.model";
import { User } from "../models/user.model";
import { LeaderBoardService } from "../services/leader-board.service";

export class LeaderBoardDataProvider {
    private $q: any;
    private service: LeaderBoardService;
    private modelsUtils: any;

    constructor(
        $q: any,
        LeaderBoardService: LeaderBoardService,
        ModelsUtils: any
    ) {
        this.$q = $q;
        this.service = LeaderBoardService;
        this.modelsUtils = ModelsUtils;
    }

    getResults(filters: object): Promise<User[]> {
        const deferred = this.$q.defer();

        this.service.getResults({ filters: filters }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    let users = [];
                    for (let i = 0; i < json.data.length; i++) {
                        let user = this.modelsUtils.user(json.data[i]);
                        user.hitrate = parseFloat(user.hitrate);
                        users.push(user);
                    }
                    deferred.resolve(users);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );

        return deferred.promise;
    }

    getRank(filters: object): Promise<number> {
        const deferred = this.$q.defer();

        this.service.getRank({ filters: filters }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );

        return deferred.promise;
    }

    getDivisions(): Promise<Division[]> {
        const deferred = this.$q.defer();

        this.service.getDivisions().then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    let divisions = [];
                    for (let i = 0; i < json.data.length; i++) {
                        divisions.push(new Division(json.data[i]));
                    }
                    deferred.resolve(divisions);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );

        return deferred.promise;
    }

    getCustomDateTemplates(): object[] {
        let lessThan3Day = new Date();
        let lessThan7Day = new Date();
        let lessThan30Day = new Date();
        let lessThan90Day = new Date();
        let lessThan1Year = new Date();

        return [
            {
                name: "Last 3 Days",
                dateStart: new Date(
                    lessThan3Day.setDate(lessThan3Day.getDate() - 2)
                ),
                dateEnd: new Date(),
            },
            {
                name: "Last 7 Days",
                dateStart: new Date(
                    lessThan7Day.setDate(lessThan7Day.getDate() - 6)
                ),
                dateEnd: new Date(),
            },
            {
                name: "Last 30 Days",
                dateStart: new Date(
                    lessThan30Day.setDate(lessThan30Day.getDate() - 29)
                ),
                dateEnd: new Date(),
            },
            {
                name: "Last 90 Days",
                dateStart: new Date(
                    lessThan90Day.setDate(lessThan90Day.getDate() - 89)
                ),
                dateEnd: new Date(),
            },
            {
                name: "Last Year",
                dateStart: new Date(
                    lessThan1Year.setDate(lessThan1Year.getDate() - 364)
                ),
                dateEnd: new Date(),
            },
        ];
    }
}

angular
    .module("vcDataProvider")
    .service("LeaderBoardDataProvider", LeaderBoardDataProvider);
